<template>
  <div :class="['menu-item', isSelected ? 'select-item' : '']" @click="($event) => onItemClicked()">
    <IconLockMask :icon-locked="item.iconLocked" :icon="item.icon" :is-locked="isLocked" />
    <p>
      {{ item.name }}
    </p>
  </div>
</template>

<script lang="ts" setup>
  import { computed, ref } from 'vue'
  import { debounce } from 'lodash'
  import type { AppInfo } from '@core/application/ApplicationManager'
  import { TimeConstants, PATH_SEPARATOR, Router as RouterConstant } from '@core/Constants'
  import IconLockMask from './IconLockMask.vue'
  import useValidateClient from '@core/compositions/HeytapAccount'
  import useAppSwitch from '@core/compositions/UseAppSwitcher'
  import router from '@/router'

  const props = defineProps<{
    isSelected: boolean
    item: AppInfo
    isTrustedClient: boolean
  }>()

  const isLocked = computed(() => !props.isTrustedClient && props.item.needClientValidation)

  const emit = defineEmits<{
    (e: 'on-click', app: AppInfo): void
  }>()

  const switchMicroApp = (item: AppInfo) => {
    emit('on-click', item)

    const route = Array.of('', RouterConstant.MICRO_APP_MAIN, item.id).join(PATH_SEPARATOR)

    // TODO：删除（与props.isSelected逻辑重复）已触发router push不再触发，
    if (location.pathname.includes(route)) {
      return
    }

    router.push(route)
  }

  const onLockedAddSwitchApp = async () => {
    if (isLocked.value) {
      return await useValidateClient(() => switchMicroApp(props.item))
    }

    return switchMicroApp(props.item)
  }

  const { switchApp } = useAppSwitch()

  const onItemClicked = debounce(
    () => {
      if (props.isSelected) {
        emit('on-click', props.item)
      } else {
        switchApp(onLockedAddSwitchApp)
      }
    },
    TimeConstants.FASTER_DEBOUNCING_IN_MS,
    { leading: true, trailing: false }
  )
</script>

<style lang="stylus" scoped>

  .menu-item
    & > p
      title(default_font_weight)
      margin-top 6px
      text-align center
      font-size 12px
      max-width 60px
      ellipsis()
</style>
